import React, { useEffect, useState } from 'react';
import Tools from '../../../cvp-webgames-core/Misc/Tools';
import { constants } from '../../../misc/constants';
import { reactToSmeDebug } from '../../../misc/tools';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import ETC02GraphUI, { ETC02GraphUIData } from './ETC02Graph';
import { getCorrectControls, mergeGraphData } from './MonitorUI';
import SingleGraphUI from './SingleGraphUI';
var setInt: any = null;
var vitals: any = null;
const VitalsUI = (props: UIProperties<VitalsUIConfig>) => {
	const [v, setV] = useState(null);
	const getLatestVitals = () => {
		return (window as any)['vitals'];
	}
	useEffect(() => {
		if(!setInt) {
			setInt = setInterval(() => {
				vitals = getLatestVitals();
				setV(vitals);
			}, 50);
		}
	}, [])
	if(vitals) {
		return (
			<div className="modal-disable-select" style={{
				backgroundColor: 'black',
				position: 'absolute',
				right: '110px',
				top: '726px',
				width: '250px',
				height: '200px',
				pointerEvents: 'all'
			}} id='vitals-ui-root' tabIndex={0} aria-label='vitals'>
				{vitals.bloodPressureNumerator > vitals.bloodPressureMinNumerator && vitals.bloodPressureDenominator > vitals.bloodPressureMinDenominator ? (<div style={{
						position: 'absolute',
						top: '0',
						width: '50%',
						height: '66%',
						borderBottom: '2px white solid',
						borderRight: '2px white solid'
					}} tabIndex={0} aria-label={'Blood Pressure. ' + Math.round(vitals.bloodPressureNumerator) + ' over ' + Math.round(vitals.bloodPressureDenominator)}>
						<p style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'relative',
							top: '10px',
							color: 'red'
						}} className="title-font">{Math.round(vitals.bloodPressureNumerator)}</p>
						<div style={{
							backgroundColor: 'red',
							width: '70%',
							height: '3px',
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)'
						}}></div>
						<p style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							color: 'red',
							width: '100%',
							position: 'absolute',
							bottom: '10px'
						}} className="title-font">{Math.round(vitals.bloodPressureDenominator)}</p>
						<p style={{
							margin: '0px',
							fontSize: '10pt',
							textAlign: 'center',
							position: 'absolute',
							bottom: '4px',
							right: '9px',
							color: 'white',
							fontWeight: 'normal'
						}} className="title-font">BP</p>
					</div>) : (<div style={{
						position: 'absolute',
						top: '0',
						width: '50%',
						height: '66%',
						borderBottom: '2px white solid',
						borderRight: '2px white solid'
					}} tabIndex={0} aria-label={'Blood Pressure. No signal'}>
						<p style={{
							margin: '0px',
							fontSize: '18pt',
							textAlign: 'center',
							position: 'relative',
							top: '50px',
							color: 'red'
						}} className="title-font">No Signal</p>
						
						<p style={{
							margin: '0px',
							fontSize: '10pt',
							textAlign: 'center',
							position: 'absolute',
							bottom: '4px',
							right: '9px',
							color: 'white',
							fontWeight: 'normal'
						}} className="title-font">BP</p>
					</div>)}
				<div style={{
					position: 'absolute',
					top: '0',
					right: '0',
					width: '50%',
					height: '33%',
					borderBottom: '2px white solid'
				}} tabIndex={0} aria-label={'Heart Rate. ' + (Math.round(vitals.heartRate) > 0 ? Math.round(vitals.heartRate) + ' Beats Per Minute' : 'No Signal')}>
					<p style={{
						margin: '0px',
						fontSize: Math.round(vitals.heartRate) > 0 ? '25pt' : '18pt',
						textAlign: 'center',
						position: 'relative',
						top: '10px',
						color: 'lime'
					}} className="title-font">{Math.round(vitals.heartRate) > 0 ? Math.round(vitals.heartRate): 'No Signal'}</p>
					
					<p style={{
						margin: '0px',
						fontSize: '10pt',
						textAlign: 'center',
						position: 'absolute',
						bottom: '4px',
						right: '9px',
						color: 'white',
						fontWeight: 'normal'
					}} className="title-font">HR</p>
				</div>
				<div style={{
					position: 'absolute',
					top: '33%',
					right: '0',
					width: '50%',
					height: '33%',
					borderBottom: '2px white solid'
				}} tabIndex={0} aria-label={'S A O 2. ' + (Math.round(vitals.sa02Value) > 0 ? Math.round(vitals.sa02Value) + '%' : 'No Signal')}>
					<p style={{
						margin: '0px',
						fontSize: (() => {
						var percentage = Math.round(vitals.sa02Value);
						return percentage > 0 ? '25pt' : '18pt';
						})(),
						textAlign: 'center',
						position: 'relative',
						top: '10px',
						color: 'cyan'
					}} className="title-font">{(() => {
						var percentage = Math.round(vitals.sa02Value);
						return percentage > 0 ? percentage : 'No Signal';
					})()}</p>

					<p style={{
						margin: '0px',
						fontSize: '15pt',
						textAlign: 'right',
						position: 'absolute',
						top: '19px',
						right: '9px',
						color: 'cyan'
					}} className="title-font">{(() => {
						var percentage = Math.round(vitals.sa02Value);
						return percentage > 0 ? '%' : '';
					})()}</p>
					
					<p style={{
						margin: '0px',
						fontSize: '10pt',
						textAlign: 'center',
						position: 'absolute',
						bottom: '4px',
						right: '9px',
						color: 'white',
						fontWeight: 'normal'
					}} className="title-font">SaO2</p>
				</div>
				<div style={{
					position: 'absolute',
					top: '66%',
					width: '50%',
					height: '33%',
					borderRight: '2px white solid'
				}} tabIndex={0} aria-label={'Respiration Rate. ' + (Math.round(vitals.respirationRate))}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '10px',
						color: 'yellow'
					}} className="title-font">{vitals.respirationRate}</p>
					
					<p style={{
						margin: '0px',
						fontSize: '10pt',
						textAlign: 'center',
						position: 'absolute',
						bottom: '4px',
						right: '9px',
						color: 'white',
						fontWeight: 'normal'
					}} className="title-font">RR</p>
				</div>
				<div style={{
					position: 'absolute',
					top: '66%',
					width: '50%',
					right: '0',
					height: '33%'
				}} tabIndex={0} id='vitals-ui-etc02' aria-label={'E T C O 2. ' + (vitals.showETC02 ? vitals.etc02Val : 'not connected')}>
					<p style={{
						margin: '0px',
						fontSize: (() => {
							// if(vitals.hasEtc02Flatline) {
							// 	return '18pt';
							// }
							return '25pt';
						})(),
						textAlign: 'center',
						position: 'relative',
						top: '10px',
						color: constants.monitor.etc02DataInVitalsUIData.lineColor
					}} className="title-font">{(() => {
						// if(vitals.hasEtc02Flatline) {
						// 	return 'No Signal';
						// }
						return !vitals.showETC02 ? '--' : vitals.etc02Val;
					})()}</p>
					
					<p style={{
						margin: '0px',
						fontSize: '10pt',
						textAlign: 'center',
						position: 'absolute',
						bottom: '4px',
						right: '9px',
						color: 'white',
						fontWeight: 'normal'
					}} className="title-font">ETCO2</p>
				</div>
				<div style={{
					position: 'absolute',
					top: '199px',
					left: '0',
					width: '250px',
					height: '140px',
					backgroundColor: 'black',
					display: 'block',
					visibility: vitals.showETC02 ? 'visible' : 'hidden'
				}}>
					<div style={{
						position: 'relative',
						top: '10px',
						overflow: 'hidden',
						width: '100%',
						height: '127px'
					}}>
						<div style={{
							width: '100%',
							height: '100%',
							position: 'absolute',
							top: '0',
							left: '0',
							pointerEvents: 'none'
						}}>
							<SingleGraphUI parameters={{
								graphs: mergeGraphData(constants.monitor.etc02DataInVitalsUIDataControls),
								initData: constants.monitor.etc02DataInVitalsUIData,
								onGetGraph: () => {
									if(vitals.hasEtc02Flatline) {
										return constants.monitor.etc02DataInVitalsUIDataControls[0].graphData;
									}
									return !constants.monitor.debug ? getCorrectControls(vitals.etc02Val, constants.monitor.etc02DataInVitalsUIDataControls).graphData : constants.monitor.etc02DataInVitalsUIDataControls[0].graphData;
								}
							}}></SingleGraphUI>
						</div>
						
						{/* {(() => {
							return (vitals.heartRate === 0 ? deadGraph : aliveGraph)
						})()} */}
					</div>
					
					<p style={{
						margin: '0px',
						fontSize: '10pt',
						textAlign: 'center',
						position: 'absolute',
						bottom: '4px',
						right: '9px',
						color: 'white',
						fontWeight: 'normal'
					}} className="title-font">ETCO2</p>
				</div>
			</div>
		);
	}


 	return (
		<div style={{
			backgroundColor: 'black',
			position: 'absolute',
			right: '110px',
			top: '726px',
			width: '250px',
			height: '200px'
		}}>
		</div>
	);

};

export interface VitalsUIConfig extends BaseConfig{
}

export default VitalsUI;